import { render, staticRenderFns } from "./TRPending.vue?vue&type=template&id=4e52afd4"
import script from "./TRPending.vue?vue&type=script&lang=js"
export * from "./TRPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports